import React, { createContext, useState } from "react";
import Home from "./Components/Home/Home/Home";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import AllProjects from "./Components/Projects/AllProjects";
import Contacts from "./Components/Contacts/Contacts";
import Blog from "./Components/Blog/Blog";
import NoMatch from "./Components/NoMatch/NoMatch";
import About from "./Components/About/About";
import { Helmet } from "react-helmet";
import Login from "./Components/Auth/Login";

export const UserContext = createContext();

function App() {
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    photo: "",
    password: "",
    logInPassword: "",
  });

  return (
    <UserContext.Provider value={{ userData, setUserData }}>
      <Router>
        <Helmet>
          <meta charSet="utf-8" />
          <meta
            name="Azim Uddin Ahamed"
            content="Azim Uddin Ahamed . 
            Web Application Developer  "
          />
        </Helmet>
        <Switch>
          <Route path="/home">
            <Home></Home>
          </Route>
          <Route path="/projects">
            <AllProjects></AllProjects>
          </Route>
          <Route path="/contact">
            <Contacts></Contacts>
          </Route>
          <Route path="/blog">
            <Blog></Blog>
          </Route>
          <Route path="/about">
            <About></About>
          </Route>
          <Route path="/login">
            <Login />
          </Route>
          <Route exact path="/">
            <Home></Home>
          </Route>
          <Route path="/*">
            <NoMatch />
          </Route>
          <Route path="/">
            <Home></Home>
          </Route>
        </Switch>
      </Router>
    </UserContext.Provider>
  );
}

export default App;
